import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import UserList from '../views/user/List.vue'
import UserLevel from '../views/user/Level.vue'
import HandCopyList from '../views/handcopy/List.vue'
import HandCopyAudit from '../views/handcopy/Audit.vue'
import HandCopyCategory from '../views/handcopy/Category.vue'
import PrintOrder from '../views/print/Order.vue'
import PrintPrice from '../views/print/Price.vue'
import ProductList from '../views/shop/Product.vue'
import ProductCategory from '../views/shop/Category.vue'
import OrderList from '../views/shop/Order.vue'
import IntegralRecord from '../views/integral/Record.vue'
import MemberRecharge from '../views/member/Recharge.vue'
import SystemSetting from '../views/system/Setting.vue'
import BannerList from '../views/banner/List.vue'
import StoreList from '../views/store/StoreList.vue'
import ModuleManage from '../views/home/ModuleManage.vue'
import TagConfig from '../views/promotion/TagConfig.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: Dashboard, meta: { title: '数据概览', icon: 'Odometer' } },
      { path: 'users', name: 'UserList', component: UserList, meta: { title: '用户管理', icon: 'User' } },
      { path: 'user-levels', name: 'UserLevel', component: UserLevel, meta: { title: '会员等级', icon: 'Medal' } },
      { path: 'handcopy', name: 'HandCopyList', component: HandCopyList, meta: { title: '手抄报管理', icon: 'Document' } },
      { path: 'handcopy-audit', name: 'HandCopyAudit', component: HandCopyAudit, meta: { title: '手抄报审核', icon: 'CircleCheck' } },
      { path: 'handcopy-category', name: 'HandCopyCategory', component: HandCopyCategory, meta: { title: '手抄报分类', icon: 'Folder' } },
      { path: 'print-orders', name: 'PrintOrder', component: PrintOrder, meta: { title: '打印订单', icon: 'Printer' } },
      { path: 'print-price', name: 'PrintPrice', component: PrintPrice, meta: { title: '打印价格', icon: 'PriceTag' } },
      { path: 'products', name: 'ProductList', component: ProductList, meta: { title: '商品管理', icon: 'Goods' } },
      { path: 'product-category', name: 'ProductCategory', component: ProductCategory, meta: { title: '商品分类', icon: 'FolderOpened' } },
      { path: 'orders', name: 'OrderList', component: OrderList, meta: { title: '商城订单', icon: 'ShoppingCart' } },
      { path: 'integral', name: 'IntegralRecord', component: IntegralRecord, meta: { title: '积分记录', icon: 'Coin' } },
      { path: 'recharge', name: 'MemberRecharge', component: MemberRecharge, meta: { title: '充值管理', icon: 'Money' } },
      { path: 'settings', name: 'SystemSetting', component: SystemSetting, meta: { title: '系统设置', icon: 'Setting' } },
      { path: 'banners', name: 'BannerList', component: BannerList, meta: { title: '轮播图管理', icon: 'Picture' } },
      { path: 'stores', name: 'StoreList', component: StoreList, meta: { title: '门店管理', icon: 'Shop' } },
      { path: 'home-modules', name: 'ModuleManage', component: ModuleManage, meta: { title: '首页模块', icon: 'Grid' } },
      { path: 'promotion-tags', name: 'TagConfig', component: TagConfig, meta: { title: '促销标签', icon: 'PriceTag' } }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
